import { useDispatch, useSelector } from "react-redux";
import airline from "../../libs/images/AirlineLogo/6E.gif";
import { flight_dateTimeFormat, set_flight_fare, StickyBottom } from "../../pages/Home";
import { setBottomSticky, setBottomStickyData, setBottomStickyData2, setSearchFlights } from "../../redux/global/global.action";
import { search_flights_data, showAlertMessage } from "../server/api";
import moment from 'moment'
import "./Return.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../loader/Loader";
export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + (h == 1 ? " h " : " h ") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " m " : " m ") : "";
  var sDisplay = s > 0 ? s + (s == 1 ? " s" : " s") : "";
  return hDisplay + mDisplay + sDisplay;
}
const ReturnFightItem1 = (props) => {
  const results = props;
  const { Segments, ResultIndex,roundtrip } = props;
  const dispatch = useDispatch();
  const airlines = useSelector((state) => state.global.airlines);
  var duration = 0;
  var noofseats = 0;
  // const search_data = useSelector((state) => state.global.search_data);
  const flight_data = useSelector((state) => state.global.flights_list);
  const flight_token = useSelector((state) => state.global.flight_token);
  // debugger;
  

  const search_data = useSelector((state) => state.global.search_data);

  const set_sticky = (data = {}, cls = "jana") => {
    console.log("set sticky", data);
    dispatch(setBottomSticky(1));;
    if (cls == "jana") {
      dispatch(setBottomStickyData({ ...data }));
    } else if (cls == "aana") {
      dispatch(setBottomStickyData2({ ...data }));
    }
  };

  

  return (
    <>

      <div class="card-header">
        <div class="container">
          <div class="row row-cols-auto">
            <div class="col">
              
            </div>
            <div class="col ReturnFightDetailsFont">
              Dep
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </div>
            <div class="col ReturnFightDetailsFont">
              Arr
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </div>
            <div class="col ReturnFightDetailsFont">
              Dur
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="currentColor"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </div>

            <div
              className="col"
              style={{ fontSize: "12px", paddingLeft: "21px" }}
            >
              Pub
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="currentColor"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </div>
            <div className="col">
            {
                roundtrip ? 
                <><input type="radio"
                onChange={() =>
                  set_sticky(
                    props,
                    props.roundtrip && props.hasOwnProperty("compid")
                      ? props.compid
                      : "jana"
                  )
                }
                name={
                  props.roundtrip && props.hasOwnProperty("compid")
                    ? props.compid
                    : "jana"
                }
                /></>
                :""
              }
            </div>
            <div class="col ReturnFightDetailsFont"></div>
          </div>
        </div>
      </div>

      <Link
      style={{
        color:'#5d646d'
      }}
          to={{
            pathname:
              "flight-details/" +
              flight_token.TokenId +
              "/" +
              flight_data.TraceId +
              "/" +
              results.ResultIndex,
          }}
        >

        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <div class="row row-cols-auto">
              <div class="col ReturnFightDetailsFont">
                {" "}
                <img
                  src={`../AirlineLogo/${results.AirlineCode}.gif`}
                  alt={results.AirlineCode}
                  style={{
                    width: '30px'
                  }}
                />
                <br />
                {results.Segments[0][0].Airline.AirlineName} - {results.AirlineCode}

              </div>

              <div class="col">
                {Segments.length
                  ? Segments.map((datas, seg_ind) => {
                    const have_next_asset = Segments.length > 1 ? true : false
                    const total_assets = datas.length
                    return datas.map((airport, index) => {
                      duration += airport.Duration;
                      noofseats = airport.NoOfSeatAvailable;
                      // if(seg_ind==0 && index==0){
                      return (
                        <>
                          <p className="ReturnFightDetailsFont">

                            {seg_ind == 0 && index == 0 ? airport.Origin.Airport.AirportCode : ''}
                            {seg_ind == 0 && index == 0 ?
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-arrow-right-short"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                                />
                              </svg>
                              : <></>
                            }
                            {have_next_asset ? (seg_ind == 1 && index == datas.length - 1 ? airport.Destination.Airport.AirportCode : "") : (seg_ind == 0 && index == datas.length - 1 ? airport.Destination.Airport.AirportCode : "")}
                          </p>
                          <p style={{ fontSize: "10px" }}>
                            <strong>{have_next_asset ? (seg_ind == 1 && index == datas.length - 1 ? flight_dateTimeFormat(airport.Origin.DepTime) + ' - ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "") : (seg_ind == 0 && index == datas.length - 1 ? flight_dateTimeFormat(airport.Origin.DepTime) + ' - ' + flight_dateTimeFormat(airport.Destination.ArrTime) : "")}</strong>

                            {/* <strong>({flight_dateTimeFormat(airport.Origin.DepTime)}) - ({flight_dateTimeFormat(airport.Destination.ArrTime)})</strong> */}
                          </p>
                        </>
                      )
                      // }

                    })
                  })
                  : ""
                }




              </div>
              <div class="col ReturnFightDetailsFont">
                {secondsToHms(duration * 60)}
                <p style={{ color: "red" }}>{noofseats} seat(s)left</p>
              </div>
              <div class="col ReturnFightDetailsFont">
                <p>Rs.{set_flight_fare(results.Fare, results.AirlineCode, airlines)}</p>
              </div>
              <div class="col ReturnFightDetailsFont">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    Email
                  </label>
                </div>
              </div>
            </div>
            <hr class="hr3" />
            <p className="ReturnFightDetailsFont" style={{ color: "brown" }}>
              {results.Segments[0][0].Airline.AirlineName} - {results.AirlineCode}
            </p>
          </li>
        </ul>
      </Link>
    </>
  );
};


const ReturnFlightDetailsItem = () => {
  const dispatch = useDispatch();
  const [loadcircle, setLoadCircle] = useState(0)
  const showBottomSticky = useSelector(
    (state) => state.global.showBottomSticky
  );

  const flight_data = useSelector((state) => state.global.flights_list);
  const calender_fare = useSelector((state) => state.global.calender_fare);
  // debugger
  const search_data = useSelector((state) => state.global.search_data);
  const filter_data = useSelector((state) => state.global.search_filters);
  const flight_token = useSelector(state => state.global.flight_token)

  const search_flight_by_calender_fare = (date) => {
    const arr = {
      ...search_data,
      journeyType: 1,
      departure_date: moment(date).format("YYYY-MM-DD"),
      TokenId: flight_token.TokenId
    };
    console.log(arr);
    search_flights_data(arr).then((res) => {
      setLoadCircle(0);

      dispatch(setSearchFlights(res));
      if (res.status) {
      } else {
        showAlertMessage("oops", res.message, false, true);
      }
    });
  };



  // useEffect(()=>{

  // },[filter_data,flight_data])
  // if(loadcircle){
  //   return <Loader />
  // }

  return (
    <>
      <div class="col-lg-9">
        <div className="card">
          {/* <div class="card-header right">
            <button type="button" class="btn btn-link">
              Email Itineraries
            </button>
            <span>|</span>
            <button type="button" class="btn btn-link">
              Next Day
            </button>
          </div> */}
          <ul class="list-group list-group-flush">
            <div class="row">
              {/* <div class="col-lg-3">
                <li
                  class="list-group-item"
                  style={{
                    border: "1px solid",
                    paddingBottom: "68px",
                  }}
                >
                  <div class="row">
                    <div class="col-lg-6" style={{ fontSize: "13px" }}>
                      PUB PRICE:
                    </div>
                    <div class="col-lg-6" style={{ fontSize: "13px" }}>
                      Rs.5555
                    </div>
                  </div>
                </li>
              </div> */}
              {calender_fare.status && calender_fare.searchResults
                ? calender_fare.searchResults.map((res) => {
                  return (
                    // <div
                    //   onClick={() =>
                    //     search_flight_by_calender_fare(
                    //       res.DepartureDate
                    //     )
                    //   }
                    //   class="item"
                    //   key={res.DepartureDate}
                    // >
                    //   <div class="pad15">
                    //     <p class="Weak-date">
                    //       {flight_dateTimeFormat(
                    //         res.DepartureDate,
                    //         true
                    //       )}
                    //     </p>
                    //     <p class="slide-price">₹ {res.Fare}</p>
                    //   </div>
                    // </div>
                    <div class="col-lg-3"
                    style={{cursor:"pointer"}}
                    onClick={() =>
                      search_flight_by_calender_fare(
                        res.DepartureDate
                      )
                    }>
                      <li
                        class="list-group-item"
                        style={{
                          border: "1px solid",
                        }}
                      >
                        <div class="row">
                          <div class="col-lg-6">
                            <img
                              src={`../AirlineLogo/${res.AirlineCode}.gif`}
                              alt={res.AirlineCode}
                              style={{
                                width: '30px'
                              }}
                            />
                            <br />
                            <p className="ReturnFightDetailsFont">{res.AirlineName} - {res.AirlineCode}</p>
                          </div>
                          <div class="col-lg-6">
                            <p className="ReturnFightDetailsFont">
                              {flight_data.status && flight_data.Origin}{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-arrow-right-short"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                                />
                              </svg>{" "}
                              {flight_data.status && flight_data.Destination}
                            </p>

                            <p className="ReturnFightDetailsFont">{flight_dateTimeFormat(
                              res.DepartureDate,
                              true
                            )}</p>

                            <p className="ReturnFightDetailsFont">Pub: Rs.{res.Fare}</p>
                          </div>
                        </div>
                      </li>
                    </div>
                  );
                })
                : ""}


            </div>
          </ul>
        </div>

        <div class="row">
          {
            filter_data.status && filter_data.hasOwnProperty("Results")
              ?

              <>

                <div class={filter_data.status && filter_data.hasOwnProperty("Results") && filter_data.Results
                  && filter_data.Results.length > 1 ? "col-lg-6" : "col-lg-12"}>

                  <div class="card" style={{
                    width: filter_data.status && filter_data.hasOwnProperty("Results") && filter_data.Results
                      && filter_data.Results.length > 1 ? "31rem" : false
                  }}  >

                    <p style={{ color: "blue" }}>{filter_data.status && filter_data.Origin} - {filter_data.status && filter_data.Destination}</p>
                    {filter_data.status &&
                      filter_data.hasOwnProperty("Results") &&
                      filter_data.Results ?

                      filter_data.Results.map((results, index) => {
                        if (index == 0) {
                          return results.map((res) => {
                            return (
                              <ReturnFightItem1 roundtrip={flight_data.Results.length > 1 ? true : false} compid={flight_data.Results.length > 1 ? "jana" : false} {...res} />
                            );
                          });
                        }

                      })
                      : <></>
                    }
                  </div>
                </div>
                {
                  filter_data.status && filter_data.hasOwnProperty("Results") && filter_data.Results
                    && filter_data.Results.length > 1
                    ?
                    <div class="col-lg-6">
                      <div class="card" style={{ width: "31rem" }}>
                        <p style={{ color: "blue" }}>{filter_data.status && filter_data.Destination} - {filter_data.status && filter_data.Origin}</p>
                        {filter_data.status &&
                          filter_data.hasOwnProperty("Results") &&
                          filter_data.Results ?

                          filter_data.Results.map((results, index) => {
                            if (index == 1) {
                              return results.map((res) => {
                                return (
                                  <ReturnFightItem1 roundtrip={flight_data.Results.length > 1 ? true : false} compid={flight_data.Results.length > 1 ? "aana" : false} {...res} />
                                );
                              });
                            }

                          })
                          : <></>
                        }

                      </div>
                    </div>

                    : ""
                }


              </>

              :
              (

                <>
                  <div class={flight_data.status && flight_data.hasOwnProperty("Results") && flight_data.Results
                    && flight_data.Results.length > 1 ? "col-lg-6" : "col-lg-12"}>

                    <div class="card" style={{
                      width: flight_data.status && flight_data.hasOwnProperty("Results") && flight_data.Results
                        && flight_data.Results.length > 1 ? "31rem" : false
                    }}  >

                      <p style={{ color: "blue" }}>{flight_data.status && flight_data.Origin} - {flight_data.status && flight_data.Destination}</p>
                      {flight_data.status &&
                        flight_data.hasOwnProperty("Results") &&
                        flight_data.Results ?

                        flight_data.Results.map((results, index) => {
                          if (index == 0) {
                            return results.map((res) => {
                              return (
                                <ReturnFightItem1 roundtrip={flight_data.Results.length > 1 ? true : false} compid={flight_data.Results.length > 1 ? "jana" : false} {...res} />
                              );
                            });
                          }

                        })
                        : <></>
                      }
                    </div>
                  </div>
                  {
                    flight_data.status && flight_data.hasOwnProperty("Results") && flight_data.Results
                      && flight_data.Results.length > 1
                      ?
                      <div class="col-lg-6">
                        <div class="card" style={{ width: "31rem" }}>
                          <p style={{ color: "blue" }}>{flight_data.status && flight_data.Destination} - {flight_data.status && flight_data.Origin}</p>
                          {flight_data.status &&
                            flight_data.hasOwnProperty("Results") &&
                            flight_data.Results ?

                            flight_data.Results.map((results, index) => {
                              if (index == 1) {
                                return results.map((res) => {
                                  return (
                                    <ReturnFightItem1 roundtrip={flight_data.Results.length > 1 ? true : false} compid={flight_data.Results.length > 1 ? "aana" : false} {...res} />
                                  );
                                });
                              }

                            })
                            : <></>
                          }

                        </div>
                      </div>

                      : ""
                  }
                </>

              )


          }


        </div>
      </div>
      {showBottomSticky ? <StickyBottom /> : ""}
    </>
  );
};
export default ReturnFlightDetailsItem;
